import {
  type ActionIconProps,
  createPolymorphicComponent,
  ActionIcon as MantineIcon,
  type MantineStyleProps,
} from "@mantine/core";

type Props = { children: React.ReactNode } & ActionIconProps &
  MantineStyleProps;

function _ActionIcon(props: Props) {
  const { children, ...actionIconProps } = props;
  const defaultOption: Omit<ActionIconProps, "children"> = {
    size: "lg",
  };
  const option = Object.assign({}, defaultOption, actionIconProps);
  return <MantineIcon {...option}>{children}</MantineIcon>;
}

export const ActionIcon = createPolymorphicComponent<"button", ActionIconProps>(
  _ActionIcon,
);
